import script from "./FormCharactersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCharactersComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormCharactersComponent.vue?vue&type=style&index=0&id=1e9b769c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9b769c"]])

export default __exports__